import React, { Fragment, memo, useState } from 'react'
import { isInStandaloneMode, isIos, isSafari } from '../data/appUtil'
import Popup from '../components/Popup'
import SvgIcon from '@material-ui/core/SvgIcon'
import Typography from '@material-ui/core/Typography'
import { getLocal, saveLocal } from '../data/store'
import LOG from '../logging/Logger'
import CookieWarning from '../components/prompts/CookieWarning'

const LS_CONFIRMED_COOKIE = 'confirmedCookies'
const LS_DISMISSED_HOMESCREEN = 'homescreenDismissed'

const shareIcon = (
  <SvgIcon viewBox='0 0 48 48' style={{ overflow: 'visible' }}>
    <path d='M30.3 13.7L25 8.4l-5.3 5.3-1.4-1.4L25 5.6l6.7 6.7z' />
    <path d='M24 7h2v21h-2z' />
    <path d='M35 40H15c-1.7 0-3-1.3-3-3V19c0-1.7 1.3-3 3-3h7v2h-7c-.6 0-1 .4-1 1v18c0 .6.4 1 1 1h20c.6 0 1-.4 1-1V19c0-.6-.4-1-1-1h-7v-2h7c1.7 0 3 1.3 3 3v18c0 1.7-1.3 3-3 3z' />
  </SvgIcon>
)

const WANT_COOKIE_MSG_IN_APP = false

export default memo(() => {
  LOG.debug('Render: Footer')

  const [confirmedCookies, setConfirmedCookies] = useState(
    getLocal(LS_CONFIRMED_COOKIE)
  )

  const [showHomescreenPrompt] = useState(
    getLocal(LS_CONFIRMED_COOKIE) &&
      !getLocal(LS_DISMISSED_HOMESCREEN) &&
      isIos() &&
      !isInStandaloneMode() &&
      isSafari()
  )

  return (
    <Fragment>
      {WANT_COOKIE_MSG_IN_APP && (
        <CookieWarning
          open={!confirmedCookies}
          messagePost='Click to accept and continue'
          onConfirm={() => {
            saveLocal(LS_CONFIRMED_COOKIE, true)
            setConfirmedCookies(true)
          }}
        />
      )}
      <Popup
        open={showHomescreenPrompt}
        variant='info'
        message={
          <Typography style={{ paddingLeft: '16px', paddingRight: '16px' }}>
            Install this Web App on your iPhone. Tap {shareIcon} then &quot;Add
            to Home Screen&quot;
          </Typography>
        }
        onCancel={() => saveLocal(LS_DISMISSED_HOMESCREEN, true)}
      />
    </Fragment>
  )
})
